import { Injectable } from '@angular/core';
import { Csticms } from './../model/csticms.model';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

@Injectable()
export class CstIcmsService extends EntityService<Csticms> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'csticms',
      pluralBaseEntityEndPoint: 'csticmss',
      urlBackend: configService.backendURL
    });
  }
}
